var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckInCustomisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.33335C1.5 5.93322 1.5 5.23316 1.77248 4.69838C2.01217 4.22797 2.39462 3.84552 2.86502 3.60584C3.3998 3.33335 4.09987 3.33335 5.5 3.33335H12.5C13.9001 3.33335 14.6002 3.33335 15.135 3.60584C15.6054 3.84552 15.9878 4.22797 16.2275 4.69838C16.5 5.23316 16.5 5.93322 16.5 7.33335V14.3334C16.5 15.7335 16.5 16.4336 16.2275 16.9683C15.9878 17.4387 15.6054 17.8212 15.135 18.0609C14.6002 18.3334 13.9001 18.3334 12.5 18.3334H5.5C4.09987 18.3334 3.3998 18.3334 2.86502 18.0609C2.39462 17.8212 2.01217 17.4387 1.77248 16.9683C1.5 16.4336 1.5 15.7335 1.5 14.3334V7.33335Z",
    fill: "#F3FDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.33335H1.5M12.3333 1.66669V5.00002M5.66667 1.66669V5.00002M6.5 13.3334L8.16667 15L11.9167 11.25M5.5 18.3334H12.5C13.9001 18.3334 14.6002 18.3334 15.135 18.0609C15.6054 17.8212 15.9878 17.4387 16.2275 16.9683C16.5 16.4336 16.5 15.7335 16.5 14.3334V7.33335C16.5 5.93322 16.5 5.23316 16.2275 4.69838C15.9878 4.22797 15.6054 3.84552 15.135 3.60584C14.6002 3.33335 13.9001 3.33335 12.5 3.33335H5.5C4.09987 3.33335 3.3998 3.33335 2.86502 3.60584C2.39462 3.84552 2.01217 4.22797 1.77248 4.69838C1.5 5.23316 1.5 5.93322 1.5 7.33335V14.3334C1.5 15.7335 1.5 16.4336 1.77248 16.9683C2.01217 17.4387 2.39462 17.8212 2.86502 18.0609C3.3998 18.3334 4.09987 18.3334 5.5 18.3334Z",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInCustomisation);
export default __webpack_public_path__ + "static/media/check-in-customisation.92e70ac1.svg";
export { ForwardRef as ReactComponent };